import { Collection } from 'modules/core/lib/mobx-rest'

import type Employee from 'modules/employees/store/models/Employee'
import AllowanceIncidence from 'modules/timeoff/store/models/AllowanceIncidence'

export class AllowanceIncidences extends Collection<AllowanceIncidence> {
  model() {
    return AllowanceIncidence
  }
}

const singleton: AllowanceIncidences = new AllowanceIncidences()

export const employeeAllowanceIncidences = (employee: Employee) => {
  return singleton.filter({
    employee_id: employee.attributes.id,
  })
}

export default singleton
